import React from 'react'
import { ConfirmationModal, ModalDescription } from 'components/Common'

interface DisconnectModalProps {
  isOpen: boolean
  loading?: boolean
  onOk: () => void
  onCancel: () => void
}

const DisconnectModal = ({
  onCancel,
  onOk,
  isOpen,
  loading
}: DisconnectModalProps) => {
  return (
    <ConfirmationModal
      title='Disconnect Leat'
      confirmLabel='Disconnect'
      isOpen={isOpen}
      onOk={onOk}
      onCancel={onCancel}
      confirmLoading={loading}
    >
      <ModalDescription>
        This will stop us from reading your Leat locations and syncing your menu
        and loyalty data across both platforms.
      </ModalDescription>
      <ModalDescription>
        To resume, you&apos;ll need to reconnect with a new Personal Access
        Token from your Slerp integration app.
      </ModalDescription>
    </ConfirmationModal>
  )
}

export default DisconnectModal
